import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@evertrue/et-components';
import EverTrue from 'app';

/**
 * Nested navigation sub-item for use within NavigationExpandableItem.
 * Renders as an indented child link.
 */
const NavigationNestedItem = ({ label, path, isActive = false, onClick, badge, trackingType }) => {
  const handleClick = () => {
    if (trackingType) {
      EverTrue.track.set('tab_view', { type: trackingType });
    }
    if (onClick) {
      onClick();
    } else if (path) {
      EverTrue.Navigator(path, true);
    }
  };

  return (
    <Button
      type="simple"
      accessibilityAttributes={{ role: 'link', tabIndex: '0' }}
      onClick={handleClick}
      className={classNames('nav-nested-item', { 'is-active': isActive })}
    >
      <span className="nav-nested-item--label">
        {label}
        {badge}
      </span>
    </Button>
  );
};

NavigationNestedItem.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  badge: PropTypes.node,
  trackingType: PropTypes.string,
};

export default NavigationNestedItem;
